export const selectFeed = state => {
  return state.feed.feed;
};
export const selectFeedss = state => {
  return state.feed.newArr;
};
export const selectStatistics = state => {
  return state.feed.statistics;
};

export const selectStatisticsView = state => {
  return state.feed.statisticsView;
};

export const selectIsFetchingFeed = state => {
  return state.feed.isFetchingFeed;
};
export const selectFeedPage = state => {
  return state.feed.page;
};
export const selectFeedLastPage = state => {
  return state.feed.lastPage;
};
export const selectTotalPosts = state => {
  return state.feed.total;
};
export const selectFeedUserId = state => {
  return state.feed.userId;
};
export const selectCurrentPost = state => {
  return state.feed.currentPost;
};
